import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const PeptideSurveyThankYou: React.FC = () => {
  const location = useLocation();
  const surveyEmail = (location.state as { email?: string })?.email;

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-6"
      style={{
        backgroundColor: 'var(--melio-cream)',
        color: 'var(--melio-charcoal)',
        fontFamily: "var(--melio-sans)",
      }}
    >
      <div className="max-w-lg text-center">
        <h1
          className="text-3xl md:text-4xl font-normal mb-6"
          style={{ fontFamily: "var(--melio-display)" }}
        >
          Thank you
        </h1>
        <p className="text-lg mb-8" style={{ color: 'var(--melio-text-muted)' }}>
          We&apos;ll send our research peptide catalogue and pricing to your email shortly. We&apos;re here to support UK research projects with HPLC-tested, third-party verified compounds.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-block px-8 py-3 text-center transition-opacity hover:opacity-90"
            style={{
              backgroundColor: 'var(--melio-charcoal)',
              color: 'var(--melio-cream)',
            }}
          >
            Return home
          </Link>
          <Link
            to={surveyEmail ? `/signup?email=${encodeURIComponent(surveyEmail)}` : '/signup'}
            className="inline-block px-8 py-3 text-center border transition-opacity hover:opacity-90"
            style={{
              borderColor: 'var(--melio-charcoal)',
              color: 'var(--melio-charcoal)',
            }}
          >
            Create account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PeptideSurveyThankYou;
